module.exports = __webpack_public_path__ + "PP2icon.png?7c5385ba70366af58b15aaffc98a789d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/PP2icon.png
// module id = 44
// module chunks = 0